import React, { useEffect, useState } from "react";
import { getIncomeLoanHomeAccountDetailAPI } from "../../../../../services/income/loan-home";
import { Link, useOutletContext } from "react-router-dom";
import { Card, Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import ModalUpdateLoan from "./ModalUpdateLoan";
import UseBanks from "../../../../../hooks/use-emps-banks";
import CardCustom from "../../../../custom/card-custom";
import { TbEdit } from "react-icons/tb";
import { FaPlus } from "react-icons/fa";
import { FaAnglesRight, FaCircle } from "react-icons/fa6";
import UseCheckStatusAdmin from "../../../../../hooks/use-check-status-admin";
import { useSelector } from "react-redux";

export default function EmpWelfareLoanHomePage() {
  const statusAdmin = UseCheckStatusAdmin();

  const { profile } = useSelector((state) => state.profileReducer);

  const optionBanks = UseBanks();
  const [loanHome, setLoanHome] = useState([]);
  const [showModal, setShowModal] = useState({ isShow: false, data: null });
  useEffect(() => {
    if (profile) {
      const param = { code: profile.code, orgId: profile.orgId };
      getIncomeLoanHomeAccountDetail(param);
    }
  }, [profile]);

  const getIncomeLoanHomeAccountDetail = async (param) => {
    const resp = await getIncomeLoanHomeAccountDetailAPI(param);
    if (!resp) return;
    if (resp.status) {
      setLoanHome(resp.result);
    } else {
      setLoanHome([]);
    }
  };
  return (
    <Col xl={12}>
      <Card border="0" className="h-full">
        <Card.Body className="">
          <h5>
            <Link
              to={-1}
              className={`my-auto text-reset text-decoration-none  pointer-event`}
            >
              <span className="text-primary">
                การลงทุน <FaAnglesRight />
              </span>
              <label className="small fw-light ms-2">สินเชื่อบ้าน</label>
            </Link>
          </h5>
          {statusAdmin?.status_id === 2 && (
            <div className="text-center">
              <label className="text-muted">
                <b>Organization Right:</b> Read Only
              </label>
            </div>
          )}
          <div className="">
            <Row className="mt-3 g-3">
              {statusAdmin?.status_id === 1 && (
                <Col xl={3}>
                  <div
                    onClick={() => {
                      setShowModal({ isShow: true, data: null });
                    }}
                    minHeight={""}
                    style={{
                      backgroundColor: "#edf4ff",
                      height: 80,
                    }}
                    className="rounded-3 pointer-event d-flex justify-content-center align-items-center"
                  >
                    <div className="text-center">
                      <FaPlus color="#2C5DFE" className="mb-1" size={24} />
                      <div style={{ fontSize: 12 }}>เพิ่มเลขที่บัญชี</div>
                    </div>
                  </div>
                </Col>
              )}

              {loanHome.map((d, i) => {
                return (
                  <Col xl={3} key={i}>
                    <CardCustom
                      minHeight={""}
                      style={{
                        backgroundColor: "#f1f1f1",
                      }}
                    >
                      <div className="p-3">
                        <div className="d-flex justify-content-between">
                          <label className="fw-bold">
                            <OverlayTrigger
                              placement="top"
                              delay={{ show: 250, hide: 400 }}
                              overlay={
                                <Tooltip id="button-tooltip">
                                  {d.active ? "Active" : "Inactive"}
                                </Tooltip>
                              }
                            >
                              <FaCircle
                                color={`${
                                  d.active === 1 ? '#2C5DFE' : '#adadad'
                                }`}
                                className="me-2"
                                style={{ fontSize: 12 }}
                              />
                            </OverlayTrigger>

                            {d.bank}
                          </label>
                          <span
                            className="pointer-event"
                            onClick={() => {
                              setShowModal({ isShow: true, data: d });
                            }}
                          >
                            <TbEdit color="#2C5DFE" />
                          </span>
                        </div>

                        <label className="small opacity-75">{d.loanAcc}</label>
                      </div>
                    </CardCustom>
                  </Col>
                );
              })}
            </Row>
          </div>
        </Card.Body>
      </Card>

      {showModal.isShow && (
        <ModalUpdateLoan
          data={showModal.data}
          optionBanks={optionBanks}
          dataUser={profile}
          param={{ code: profile.code, orgId: profile.orgId }}
          fnGetData={() =>
            getIncomeLoanHomeAccountDetail({
              code: profile.code,
              orgId: profile.orgId,
            })
          }
          onCancel={() => setShowModal({ isShow: false, data: null })}
          open={showModal.isShow}
        />
      )}
    </Col>
  );
}
